/**
 * Safe-area insets for notch / home-indicator / status-bar padding.
 *
 * Capacitor exposes these via CSS env() variables on native and the
 * SafeArea plugin when deeper control is needed. For now we read the
 * CSS env values and fall back to 0 on web.
 *
 * Usage in JSX:  style={{ paddingTop: safeArea.top }}
 */
export function getSafeAreaInsets() {
  const read = (variable) => {
    const raw = getComputedStyle(document.documentElement)
      .getPropertyValue(variable)
      .trim();
    return raw ? parseInt(raw, 10) : 0;
  };

  return {
    top: read('--sat') || 0,
    bottom: read('--sab') || 0,
    left: read('--sal') || 0,
    right: read('--sar') || 0,
  };
}

/**
 * Inject CSS variables from the viewport meta env() values so they are
 * readable by getSafeAreaInsets(). Call once in V2App before first render.
 */
export function injectSafeAreaVars() {
  const style = document.documentElement.style;
  style.setProperty('--sat', 'env(safe-area-inset-top)');
  style.setProperty('--sab', 'env(safe-area-inset-bottom)');
  style.setProperty('--sal', 'env(safe-area-inset-left)');
  style.setProperty('--sar', 'env(safe-area-inset-right)');
}
